import call from "@brainspore/celadon-base/service/http";
import ExemptionConstants from "./ExemptionConstants";
import { helper } from "../dashboard/utils";
export default {
  namespaced: true,
  state: {
    exemptibleUnits: [],
    exemptions: [],
    exemption: {},
    attachmentDialog: false,
    proforma: "",
    receipt: "",
    exemptionLetter: "",
    grades: [],
    acknoledgementLetter: "",
    accreditedInstitute: [],
    awardingBodies: [],
    educationLevels: [],
  },
  mutations: {
    MUTATE: (state, payload) => {
      state[payload.state] = payload.data;
    },
  },
  getters: {
    exemptionGetter: (state) => (value) => state[value],
  },
  actions: {
    exemptibleUnits({ commit }) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", ExemptionConstants.EXEMPTIBLE_UNITS)
        .then((response) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("MUTATE", {
            state: "exemptibleUnits",
            data: response.data.data.shift()["programmeStages"].shift()[
              "programmeUnits"
            ],
          });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    exemptions({ commit }) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", ExemptionConstants.EXEMPTIONS)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("MUTATE", { state: "exemptions", data: res.data.data });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    saveExemptedUnits({ commit }, payload) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", ExemptionConstants.EXEMPTIONS, payload)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("goToPayment", res.data.data[0].no);
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    getExemption({ commit, dispatch }, payload) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      let decrypted = helper.decrypt(payload);
      call("get", ExemptionConstants.getExemption(decrypted))
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("MUTATE", {
            state: "exemption",
            data: res.data.data[0],
          });
          dispatch("getExemptionProforma", decrypted);
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    patchExemption({ commit }, payload) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", ExemptionConstants.patchExemption, payload)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          if (res.data.data[0].postedReceiptNo === "") {
            Event.$emit("goToPayment", res.data.data[0].no);
          }
          Event.$emit("ApiSuccess", "Successfully Updated Exemption Document");
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    deleteExemption({ commit, dispatch }, payload) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", ExemptionConstants.deleteExemption, payload)
        .then(() => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          dispatch("exemptions");
          Event.$emit(
            "ApiSuccess",
            "You've successfully deleted Exemption Document",
          );
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    deleteLine({ commit, dispatch }, payload) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", ExemptionConstants.deleteLine, payload)
        .then(() => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          dispatch("getExemption", helper.encrypt(payload.documentNo));
          Event.$emit("ApiSuccess", "Successfully deleted Exemption Line");
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    deleteAttachment({ commit, dispatch }, payload) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", ExemptionConstants.deleteAttachment, payload)
        .then(() => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          dispatch("getExemption", helper.encrypt(payload.documentNo));
          Event.$emit("ApiSuccess", "Successfully deleted Attachment");
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    setAttachmentDialog({ commit }, payload) {
      commit("MUTATE", { state: "attachmentDialog", data: payload });
    },
    getExemptionProforma({ commit }, payload) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", ExemptionConstants.proforma(payload))
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("MUTATE", {
            state: "proforma",
            data: process.env.VUE_APP_TEMP_URL + res.data.data[0],
          });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    getExemptionReceipt({ commit }, payload) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", ExemptionConstants.receipt(payload))
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("MUTATE", {
            state: "receipt",
            data: process.env.VUE_APP_TEMP_URL + res.data.data[0],
          });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    // exemption letter
    exemptionLetter({ commit }, payload) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", ExemptionConstants.EXEMPTION_LETTER(payload))
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("MUTATE", {
            state: "exemptionLetter",
            data: process.env.VUE_APP_TEMP_URL + res.data.data[0],
          });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    acknoledgementLetter({ commit }, payload) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", ExemptionConstants.ACKNOWLEDGEMENT_LETTER(payload))
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("MUTATE", {
            state: "acknoledgementLetter",
            data: process.env.VUE_APP_TEMP_URL + res.data.data[0],
          });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    getExemptionGradesSetup({ commit }) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", ExemptionConstants.gradeSetup)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("MUTATE", { state: "grades", data: res.data.data });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    getaccreditedInstitute({ commit }) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", ExemptionConstants.ACCREDITEDINSTITUTE)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("MUTATE", {
            state: "accreditedInstitute",
            data: res.data.data,
          });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    getawardingBodies({ commit }) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", ExemptionConstants.AWARDINGBODIES)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("MUTATE", { state: "awardingBodies", data: res.data.data });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    getEducationLevels({ commit }) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", ExemptionConstants.EDUCATION_LEVELS)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("MUTATE", { state: "educationLevels", data: res.data.data });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    resubmitDeferedExemption({ commit }, payload) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", ExemptionConstants.resubmit, payload)
        .then(() => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", "Successfully resubmitted Document");
          Event.$emit("back");
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
  },
};
